import { render } from "./AddMidCategory.vue?vue&type=template&id=6f2ab7f6"
import script from "./AddMidCategory.vue?vue&type=script&lang=js"
export * from "./AddMidCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__